import React, { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';

import { StepWrapperBox } from '../../styledComponent/Boxes.style';
import { BaseStep, StepProps, TitleAndDescriptionProps, StepWizardProps } from '../../common/BaseStep';
import { useMst } from '../../../models/rootModel';
import { OpenRoom } from './OpenRoom';
import { Loader } from '../../common/Loader';
import { getColor } from '../../common/UICommon';

const NUM_OF_ROOMS = 'numOfRooms';
const DEFAULT_SEGMENT = 'relationships';
const DEFAULT_MINIMUM_WAIT_TIME = 3000;

interface RoomsSuggestionsStepProps extends TitleAndDescriptionProps, StepProps, StepWizardProps {
  alternativeTitle?: string;
  alternativeDescription?: string;
  waitingTitle?: string;
  waitingDescription?: string;
  milliseconds?: number;
}

export const RoomsSuggestions = observer((props: RoomsSuggestionsStepProps) => {
  let timeout = useRef<NodeJS.Timeout>();
  const [isMinimumTimeEnd, setIsMinimumTimeEnd] = useState(false);
  const [isOpenRoomsFetch, setIsOpenRoomsFetch] = useState(false);
  const showRooms = isOpenRoomsFetch && isMinimumTimeEnd;

  const {
    isActive,
    ctaButtonTitle,
    title,
    description,
    alternativeTitle,
    alternativeDescription,
    milliseconds,
    waitingTitle,
    waitingDescription,
    nextStep
  } = props;

  const { Group, UserDiscoveryResponse } = useMst();

  useEffect(() => {
    if (isActive) {
      timeout.current = setTimeout(() => {
        setIsMinimumTimeEnd(true);
      }, milliseconds ?? DEFAULT_MINIMUM_WAIT_TIME);

      Group.getOpenGroupsBySegment(UserDiscoveryResponse.segment || DEFAULT_SEGMENT)
        .catch((err) => {
          console.log('getOpenGroupsBySegment', err);
        })
        .finally(() => {
          setIsOpenRoomsFetch(true);
        });

      return window.scrollTo(0, 0);
    }
    return () => {
      clearTimeout(timeout.current);
    };
  }, [isActive, Group, UserDiscoveryResponse, milliseconds]);

  const getTitleAndDescription = () => {
    if (showRooms) {
      if (!Group.openGroups.length) {
        return {
          title: alternativeTitle,
          description: alternativeDescription,
        };
      }

      return {
        title: title?.includes(NUM_OF_ROOMS) ? title?.replace(NUM_OF_ROOMS, String(Group.openGroups.length)) : title,
        description,
      };
    } else {
      return { title: waitingTitle, description: waitingDescription };
    }
  };

  return (
    <>
      {isActive && (
        <div style={{ backgroundColor: getColor('GRAY_50') }}>
          <BaseStep {...props} {...getTitleAndDescription()} ctaButtonTitle={showRooms ? ctaButtonTitle : ''}>
            <StepWrapperBox>
              {showRooms ? (
                Group.openGroups?.map((openGroup) => <OpenRoom key={openGroup.groupId} openGroup={openGroup} onClick={nextStep} />)
              ) : (
                <Loader />
              )}
            </StepWrapperBox>
          </BaseStep>
        </div>
      )}
    </>
  );
});
